import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import React from "react";

import { HealthDirect_ExternalLink } from "../../utils/urls";

export const HealthDirectLogo: React.FC<{ width: number }> = ({ width }) => {
  const style = { width };

  const data = useStaticQuery(graphql`
    query {
      mchriImage: file(relativePath: { eq: "healthdirect-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 220) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <a
      href={HealthDirect_ExternalLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Img
        style={style}
        alt={"Monash Centre for Health Research and Implementation (MCHRI)"}
        fluid={data.mchriImage.childImageSharp.fluid}
      />
    </a>
  );
};
